export default __webpack_public_path__ + "static/26-augmented-reality-24d00b2684d98551090664456ed0f275.png";